import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import Menu, { MenuItem } from 'components/common/Menu';
import DeleteMenu from 'components/common/DeleteMenu';
import Badge from 'components/common/Badge';
import IconButton from 'components/common/IconButton';
import IconMoveVert from 'components/icons/IconMoveVert';
import IconMoreVert from 'components/icons/IconMoreVert';
import IconArrowHeadBottom from 'components/icons/IconArrowHeadBottom';
import ReferralSourceCreateEditDialog from 'components/settings/ReferralSourceCreateEditDialog';
import Tooltip from 'components/common/Tooltip';
import Typography from '@material-ui/core/Typography';
import IconLink from 'components/icons/IconLink';
import Link from 'components/common/Link';

import pxToRem from 'styles/pxToRem';
import pxToEm from 'styles/pxToEm';

import splitLongWords from 'utils/splitLongWords';

import { removePatientResource } from 'redux/modules/patients';

const styles = theme => ({
  gridContact: {
    position: 'relative',
    '&:hover': {
      cursor: 'pointer',
    },
    '&:hover $typographyContact': {
      color: theme.palette.primary[500],
    },
    '&:hover $typographyContactHint': {
      display: 'block',
    },
  },
  gridPrimaryContact: {
    position: 'relative',

    '& $typographyContact': {
      fontWeight: '500',
    },
    '& $typographyContactHint': {
      color: theme.palette.text.primary,
      textTransform: 'none',
    },
    '&:hover $typographyContactHint': {
      display: 'block',
    },
  },
  typographyContact: {
    transition: theme.transitions.create(['color'], {
      duration: theme.transitions.duration.short,
    }),
  },
  typographyContactHint: {
    display: 'none',
    position: 'absolute',
    zIndex: 100,
    top: -4,
    padding: 8,
    right: '100%',
    textTransform: 'uppercase',
    color: theme.palette.primary[500],
    backgroundColor: theme.palette.common.white,
    whiteSpace: 'nowrap',
  },
  iconMoreVert: {
    width: 24,
    height: 24,
  },
  iconLink: {
    color: theme.palette.primary[500],
    marginBottom: -4,
  },
  tooltipList: {
    textAlign: 'left',
  },
  gridItemShrink: {
    paddingTop: 10,
    flexShrink: 1,
  },
  gridItem: {
    display: 'flex',
    minHeight: 48,
    alignItems: 'center',
  },
  gridItemLink: {
    minWidth: 24,
  },
  gridItemExpandButton: {
    minWidth: 48,
  },
  gridItemContact: {
    display: 'flex',
    minHeight: 28,
    alignItems: 'center',
  },
  gridItemContactPhone: {
    minHeight: 28,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  buttonMove: {
    position: 'relative',
    top: 1,
  },
  iconMoveVert: {
    width: 10,
    height: 16,
  },
  iconArrowHeadBottom: {
    width: 12,
    height: 8,
    marginLeft: 4,
  },
  typographyContactCount: {
    marginLeft: -16,
  },
  iconArrowHeadBottomExpanded: {
    transform: 'rotate(180deg)',
  },
  tooltipContact: {
    display: 'block',
    margin: -12,
    padding: 12,
  },
  badgePrimaryContact: {
    marginRight: 8,
  },
  desktopOnly: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
});

class ReferralSourceItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      editDialogOpen: false,
      deleteMenuOpen: false,
      allContactsVisible: false,
    };

    this.onMenuButtonClick = this.onMenuButtonClick.bind(this);
    this.onMenuClose = this.onMenuClose.bind(this);
    this.onEditMenuItemClick = this.onEditMenuItemClick.bind(this);
    this.onEditDialogClose = this.onEditDialogClose.bind(this);
    this.onDeleteMenuItemClick = this.onDeleteMenuItemClick.bind(this);
    this.onDeleteCancel = this.onDeleteCancel.bind(this);
    this.onDeleteSubmit = this.onDeleteSubmit.bind(this);
    this.onContactsExpandButtonClick = this.onContactsExpandButtonClick.bind(this);
  }

  onMenuButtonClick(event) {
    this.setState({
      anchorEl: event.currentTarget,
      deleteMenuOpen: false,
    });
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onEditMenuItemClick() {
    this.onMenuClose();
    this.setState({ editDialogOpen: true });
  }

  onEditDialogClose() {
    this.setState({ editDialogOpen: false });
  }

  onDeleteMenuItemClick() {
    this.setState({ deleteMenuOpen: true });
  }

  onDeleteCancel() {
    this.setState({ anchorEl: null });
  }

  onDeleteSubmit() {
    const { onRemove } = this.props;
    onRemove();
    this.setState({ anchorEl: null });
  }

  onContactsExpandButtonClick() {
    this.setState({ allContactsVisible: !this.state.allContactsVisible });
  }

  render() {
    const { Email, ID, dragHandleClassName, dragDisabled, dragged, onSetPrimaryContact, classes, ...otherProps } = this.props;
    const { anchorEl, deleteMenuOpen, editDialogOpen, allContactsVisible } = this.state;
    const open = Boolean(anchorEl);
    const sortedContacts = this.props['Primary Contact'] && this.props['Primary Contact'].ID
      ? this.props['Referral Source Contact'].sort((a, b) => {
        if (a.ID === this.props['Primary Contact'].ID) {
          return -1;
        }
        return 0;
      })
      : this.props['Referral Source Contact'];
    const visibleContacts = allContactsVisible ? sortedContacts : sortedContacts.slice(0, 1);
    return (
      <Grid
        className={classes.root}
        container
        spacing={0}
        wrap="nowrap"
        justify="space-between"
        alignItems="flex-start"
      >
        <Grid item>
          <IconButton
            className={classNames(classes.buttonMove, dragHandleClassName)}
            disabled={dragDisabled}
            tooltipContent={(!dragDisabled && !dragged) ? 'Drag it to Change Position' : null}
          >
            <IconMoveVert className={classes.iconMoveVert} />
          </IconButton>
        </Grid>
        <Grid item xs={3} className={classes.gridItem}>
          <Link
            onClick={this.onEditMenuItemClick}
            breakWord
            size="md"
          >  
            {splitLongWords(otherProps['Name of source'])}
          </Link>
        </Grid>
        <Grid item xs={10} className={classes.gridItemShrink}>
          {visibleContacts.map(item => (
            <Tooltip
              key={item.ID}
              className={classes.tooltipContact}
              color={item.ID === this.props['Primary Contact'].ID ? 'white' : 'dark'}
              disableGutters={item.ID === this.props['Primary Contact'].ID ? false : true}
              content={item.ID === this.props['Primary Contact'].ID
                ? (<Typography>
                    <Badge
                      className={classes.badgePrimaryContact}
                      color="primary"
                    >
                      1
                    </Badge>
                    Primary Contact
                  </Typography>)
                : 'Set as primary contact'}
              disabled={!allContactsVisible}
              placement="left"
            >
              <Grid
                container
                spacing={0}
                wrap="nowrap"
                justify="space-between"
                alignItems="flex-start"
                {...(allContactsVisible && item.ID !== this.props['Primary Contact'].ID) ? {
                  className: classes.gridContact,
                  onClick: () => {
                    onSetPrimaryContact({ id: ID, referral_source_contact_id: item.ID });
                  },
                } : {}}
                {...(allContactsVisible && item.ID === this.props['Primary Contact'].ID) ? {
                  className: classes.gridPrimaryContact,
                } : {}}
              >
                <Grid item xs={2} className={classes.gridItemContact}>
                  <Typography className={classes.typographyContact}>
                    {item['Contact Name'] ? splitLongWords(item['Contact Name']) : ''}
                  </Typography>
                </Grid>
                <Grid item xs={6} className={classes.gridItemContactPhone}>
                  <Typography className={classes.typographyContact}>
                    {item.Phone}
                  </Typography>
                  {item.Fax && 
                    <Typography className={classes.typographyContact}>
                      Fax: {item.Fax}
                    </Typography>
                  }
                </Grid>
                <Grid item xs={4} className={classNames(classes.gridItemContact, classes.desktopOnly)}>
                  <Typography className={classes.typographyContact}>
                    {item.Email ? splitLongWords(item.Email) : ''}
                  </Typography>
                </Grid>
              </Grid>
            </Tooltip>
          ))}
        </Grid>
        <Grid item className={classNames(classes.gridItem, classes.gridItemExpandButton)}>
          {this.props['Referral Source Contact'].length > 1 &&
            <IconButton
              onClick={this.onContactsExpandButtonClick}
              tooltipContent={allContactsVisible ? 'Hide All Contacts' : 'Open All Contacts'}
            >
              {(!allContactsVisible && this.props['Referral Source Contact'].length > 1) &&
                <Typography
                  className={classes.typographyContactCount}
                  color="primary"
                  component="span"
                >
                  +{this.props['Referral Source Contact'].length - 1}
                </Typography>
              }
              <IconArrowHeadBottom
                className={classNames(classes.iconArrowHeadBottom, {
                  [classes.iconArrowHeadBottomExpanded]: allContactsVisible,
                })}
              />
            </IconButton>
          }
        </Grid>
        <Grid item className={classNames(classes.gridItem, classes.gridItemLink)}>
          {((this.props['Sales Representative'] && this.props['Sales Representative'].length > 0)
            || (this.props.Prescriber && this.props.Prescriber.length > 0)) &&
            <Tooltip
              content={
                <div className={classes.tooltipList}>
                  {(this.props.Prescriber && this.props.Prescriber.length > 0) &&
                    <Fragment>
                      <Typography variant="caption" gutterBottom>
                        Linked Prescribers:
                      </Typography>
                      {this.props.Prescriber.map(item => (
                        <Typography key={item.ID}>
                           {`${item['First Name']} ${item['Last Name']}`}
                        </Typography>
                      ))}
                    </Fragment>
                  }
                  {(this.props['Sales Representative'] && this.props['Sales Representative'].length > 0) &&
                    <Fragment>
                      <Typography variant="caption" gutterBottom>
                        Linked Sales:
                      </Typography>
                      {this.props['Sales Representative'].map(item => (
                        <Typography key={item.ID}>
                           {`${item['First Name']} ${item['Last Name']}`}
                        </Typography>
                      ))}
                    </Fragment>
                  }
                </div>
              }
              placement="top"
            >
              <IconLink className={classes.iconLink} />
            </Tooltip>
          }
        </Grid>
        <Grid item>
          <IconButton
            aria-label="More"
            aria-owns={open ? `${ID}-referral-source-more-menu` : null}
            aria-haspopup="true"
            onClick={this.onMenuButtonClick}
            tooltipContent="Open Menu"
          >
            <IconMoreVert
              className={classes.iconMoreVert}
            />
          </IconButton>
          <Menu
            id={`${ID}-referral-source-more-menu`}
            anchorEl={anchorEl}
            open={open}
            onClose={this.onMenuClose}
            list={!deleteMenuOpen}
          >
            {deleteMenuOpen ? (
              <DeleteMenu
                text="Are you sure you want to remove this referral source?"
                onCancel={this.onDeleteCancel}
                onSubmit={this.onDeleteSubmit}
                submitButtonText="Remove"
              />
            ) : (
              <Fragment>
                <MenuItem
                  onClick={this.onEditMenuItemClick}
                >
                  Edit
                </MenuItem>
                <MenuItem
                  color="warning"
                  onClick={this.onDeleteMenuItemClick}
                >
                  Remove
                </MenuItem>
              </Fragment>
            )}
          </Menu>
          <ReferralSourceCreateEditDialog
            form={`referralSourceEdit-${ID}`}
            open={editDialogOpen}
            ID={ID}
            initialValues={{
              'Name of source': otherProps['Name of source'],
              ...otherProps['Cooperate From']
                ? { 'Cooperate from': otherProps['Cooperate From'] } : {},
              ...this.props['Referral Source Contact'] ? {
                'Referral Source Contact': this.props['Referral Source Contact'].map(item => ({
                  ID: item.ID,
                  Phone: item.Phone,
                  Fax: item.Fax,
                  Email: item.Email,
                  'Contact Name': item['Contact Name'],
                })),
              } : {},
              'Sales Representative': this.props['Sales Representative'].map(item => ({
                value: item.ID,
                label: `${item['First Name']} ${item['Last Name']}`,
              })),
              'Prescriber': this.props.Prescriber.map(item => ({
                value: item.ID,
                label: `${item['First Name']} ${item['Last Name']}`,
              })),
            }}
            onClose={this.onEditDialogClose}
          />
        </Grid>
      </Grid>
    );
  }
}

ReferralSourceItem.propTypes = {
  ID: PropTypes.number.isRequired,
  'Name of source': PropTypes.string.isRequired,
  Email: PropTypes.string,
  'Referral Source Contact': PropTypes.arrayOf(PropTypes.shape({
    Phone: PropTypes.string,
  })),
  dragHandleClassName: PropTypes.string,
  dragDisabled: PropTypes.bool,
  dragged: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
  onSetPrimaryContact: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    iconMoreVert: PropTypes.string.isRequired,
  }).isRequired,
};

ReferralSourceItem.defaultProps = {
  Email: null,
  Phone: null,
  'Referral Source Contact': null,
  dragHandleClassName: '',
  dragDisabled: false,
  dragged: false,
};

export default withStyles(styles)(ReferralSourceItem);



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/ReferralSource/ReferralSourceItem.js